import { useCurrentModule } from '../components';
export const useCycleAvailability = (productId, cycle) => {
  var _isCycleAvailableQuer, _lowestCycleAvailable;
  const module = useCurrentModule();
  const lowestCycleAvailableQuery = module.SDK.switchApiClient.hooks.useLowestCycleAvailable({
    productId: productId || ''
  }, Boolean(productId));
  const isCycleAvailableQuery = module.SDK.switchApiClient.hooks.useIsCycleAvailable({
    productId: productId || '',
    cycle: cycle || {}
  }, Boolean(productId && cycle));
  const isLoading = isCycleAvailableQuery.isLoading || lowestCycleAvailableQuery.isLoading;
  return {
    isCycleAvailable: !!((_isCycleAvailableQuer = isCycleAvailableQuery.data) != null && _isCycleAvailableQuer.isCycleAvailable),
    lowestCycleAvailable: (_lowestCycleAvailable = lowestCycleAvailableQuery.data) == null ? void 0 : _lowestCycleAvailable.lowestCycleAvailable,
    isLoading
  };
};
//# sourceMappingURL=useCycleAvailability.js.map